<h2>Eenvoudig direct regelen</h2>
<div class="insurance-control">
    <ng-container *ngFor="let group of displayGroups">
        <ins-details-accordion *ngIf="group.visible" [onDark]="onDark" class="insurance-control__accordion">
            <ins-details-accordion-item>
                <span title>
                    <span class="insurance-control__title">
                        <span class="insurance-control__title-icon">
                            <svg class="svg-icon svg-icon--m">
                                <use [attr.href]="'assets/icons-general.svg#' + group.icon"></use>
                            </svg>
                        </span>
                        {{ group.name }}
                    </span>
                </span>
                <div content>
                    <ng-container *ngFor="let link of group.items">
                        <ng-container *ngIf="link.visible">
                            <button
                                *ngIf="link.id !== insuranceControlOptionIdEnum.InsuranceAdd"
                                class="insurance-control__link"
                                (click)="clickAction(link)"
                                [disabled]="!(allProductsLoaded$ | async) && !userLoaded"
                                [id]="'zelf_regelen-' + link.id"
                            >
                                <span class="insurance-control__link-icon">
                                    <svg class="svg-icon svg-icon--m">
                                        <use [attr.href]="'assets/icons-general.svg#' + link.icon"></use>
                                    </svg>
                                </span>
                                <span class="insurance-control__link-text">{{ link.name }}</span>
                            </button>
                            <div
                                *ngIf="link.id === insuranceControlOptionIdEnum.InsuranceAdd"
                                insDropdown
                                #dropdownInsurance="dropdown"
                            >
                                <button
                                    insDropdownToggle
                                    (click)="dropdownInsurance.toggle()"
                                    [disabled]="!(allProductsLoaded$ | async) && !userLoaded"
                                    class="insurance-control__link"
                                    [id]="'zelf_regelen-' + link.id"
                                >
                                    <span class="insurance-control__link-icon">
                                        <svg class="svg-icon svg-icon--m">
                                            <use [attr.href]="'assets/icons-general.svg#' + link.icon"></use>
                                        </svg>
                                    </span>
                                    <span>{{ link.name }}</span>
                                </button>
                                <div insDropdownMenu>
                                    <ins-insurances-list></ins-insurances-list>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ins-details-accordion-item>
        </ins-details-accordion>
    </ng-container>
</div>
